/**
 * @module
 * 
 * @format
 */

import {content, Engine, rootScope, source} from '@acng/frontend-stargazer';
import {globalValue} from '@acng/frontend-relativity';
import {IS, guard} from '@acng/frontend-rubicon';
import {append} from '@acng/frontend-bounty/dom/template.js';
import {extend, keyIn} from '@acng/frontend-bounty/object.js';
import {set} from '@acng/frontend-bounty/dom/attribute.js';

import {media} from '../../core/service/env.js';
import {Feature} from '../../core/model/feature.js';
import {registerPurge} from '../../core/purge.js';
import {ctxBonusList} from '../context/bonus-list.js';
import {NOVA_TEASER} from '../../layout/style/teaser.js';
import {TIMING_END, TIMING_START} from '../../layout/attribute/common.js';
import {DATA_DELAY} from '../../layout/element/slideshow.js';
import {SEQUENCE_NAME} from '../../layout/attribute/sequence-name.js';
import {BONUS_TEASER_FORMAT} from '../model/bonus.js';

export const name = 'payment';
export const feature = new Feature(name);

/**
 * @returns {Promise<import('acng/special/run/source.js').Module & {
 *   default: (name: string, format: Valid<typeof BONUS_TEASER_FORMAT>, fsk: FskLevel) => string;
 * }>}
 */
export const getBonusModule = () => import(`${media.assets_ext}/bonus.js`);

export const teaser = Engine.root.spawn('bonus-teaser');
registerPurge(teaser.template);

source(teaser, async ([name, format]) => {
  const {config, source} = await getBonusModule();

  for (const bonus of globalValue(ctxBonusList)) {
    if (bonus.name == name) {
      const src = await source(name, format);
      const engine = teaser.spawn(name, format);
      const {template} = engine;
      ASSERT: guard(src, IS(URL));

      // template.setAttribute('debug', '');
      // TODO(1.)
      template.className = `${NOVA_TEASER} bonus ${bonus.name} bonus-${bonus.name}`;
      set(template, TIMING_START, bonus.created_at);
      set(template, TIMING_END, bonus.expires_at ?? '');
      set(template, DATA_DELAY, '10');
      set(template, 'data-bonus', bonus.name);
      await engine.fetch(src, config(extend(rootScope, {...bonus, format})));
    }
  }
});

/**
 * TODO check this out! looks like an *engine compile callback* :)
 */
const slideshow = Engine.root.spawn('payment-slideshow');
registerPurge(slideshow.template);

const formatToSequenceName = {
  overlay: /** @type {const} */ ('slideshow-user-home'),
  sidebar: /** @type {const} */ ('slideshow-sidebar'),
};

source(slideshow, async ([format]) => {
  ASSERT: guard(format, BONUS_TEASER_FORMAT);

  if (!keyIn(formatToSequenceName, format)) {
    return;
  }

  const {template: sequence} = slideshow.spawn(format);
  //DEBUG: if (VERBOSE) console.log('create payment bonus teaser slides', {format});

  for (const bonus of globalValue(ctxBonusList)) {
    const scene = await teaser.lookup(bonus.name, format);

    set(scene, SEQUENCE_NAME, formatToSequenceName[format]);
    append(sequence, scene);
  }
});
